import { useEffect, useRef } from "react";

// Reexecuta uma função (ex.: load de dados) quando a conexão é restabelecida.
export function useOnReconnect(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const handler = () => { try { ref.current && ref.current(); } catch (e) { /* noop */ } };
    window.addEventListener("app:reconnect", handler);
    return () => window.removeEventListener("app:reconnect", handler);
  }, []);
}
